import { Box, BoxProps } from "../../atoms/Box";

export type ListItemSecondaryContentProps = BoxProps & {
  // for when checkbox spacing required
  checkbox?: boolean;
  // for when avatar spacing required
  avatar?: boolean;
  // for when secondary content is outside of the list item itself
  outside?: boolean;
};

export function ListItemSecondaryContent({
  checkbox,
  avatar,
  outside,
  children,
  ...props
}: ListItemSecondaryContentProps): React.ReactElement | null {
  return children ? (
    <Box
      className="mr2 my2"
      {...props}
      style={
        checkbox || avatar
          ? {
              ...props.style,
              marginLeft: (checkbox && avatar ? 106 : checkbox ? 46 : 60) + (outside ? 8 : 0),
            }
          : props.style
      }
    >
      {children}
    </Box>
  ) : null;
}
